/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthSubmissionStatus } from './PalAuthSubmissionStatus';
import {
    PalAuthSubmissionStatusFromJSON,
    PalAuthSubmissionStatusFromJSONTyped,
    PalAuthSubmissionStatusToJSON,
    PalAuthSubmissionStatusToJSONTyped,
} from './PalAuthSubmissionStatus';

/**
 * Enough of the owning PAL submission to render a standalone carve-out page (patient, payer, facility) without a second request.
 * @export
 * @interface CarveOutSubmissionContext
 */
export interface CarveOutSubmissionContext {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    facility_id?: string;
    /**
     * 
     */
    patient_first_name?: string;
    /**
     * 
     */
    patient_last_name?: string;
    /**
     * 
     */
    payer_name?: string;
    /**
     * 
     */
    auth_platform_name?: string;
    /**
     * 
     */
    submission_status?: PalAuthSubmissionStatus;
}



/**
 * Check if a given object implements the CarveOutSubmissionContext interface.
 */
export function instanceOfCarveOutSubmissionContext(value: object): value is CarveOutSubmissionContext {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    return true;
}

export function CarveOutSubmissionContextFromJSON(json: any): CarveOutSubmissionContext {
    return CarveOutSubmissionContextFromJSONTyped(json, false);
}

export function CarveOutSubmissionContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutSubmissionContext {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'patient_first_name': json['patient_first_name'] == null ? undefined : json['patient_first_name'],
        'patient_last_name': json['patient_last_name'] == null ? undefined : json['patient_last_name'],
        'payer_name': json['payer_name'] == null ? undefined : json['payer_name'],
        'auth_platform_name': json['auth_platform_name'] == null ? undefined : json['auth_platform_name'],
        'submission_status': json['submission_status'] == null ? undefined : PalAuthSubmissionStatusFromJSON(json['submission_status']),
    };
}

export function CarveOutSubmissionContextToJSON(json: any): CarveOutSubmissionContext {
    return CarveOutSubmissionContextToJSONTyped(json, false);
}

export function CarveOutSubmissionContextToJSONTyped(value?: CarveOutSubmissionContext | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'facility_id': value['facility_id'],
        'patient_first_name': value['patient_first_name'],
        'patient_last_name': value['patient_last_name'],
        'payer_name': value['payer_name'],
        'auth_platform_name': value['auth_platform_name'],
        'submission_status': PalAuthSubmissionStatusToJSON(value['submission_status']),
    };
}

